import React, { useState } from "react";
import GenPortraits from "./GenPortraits";
import AiComposzNavbarenh from "./AiComposzNavbarenh";

class Enhance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      mobile: false,
      userID: props.user_id,
      userName: props.user_name
    };
    // document.cookie = "cartCounter=25;";
  }

  componentDidMount() {
    this.checkDevice();
    if (this.props.imgcredits < 1) {
      alert("Please purchase 'Image Credits' before continuing...");
      window.location.href = "/";
    }
  }

  checkDevice = () => {
    /* Storing user's device details in a variable*/
    let details = navigator.userAgent;

    /* Creating a regular expression  
      containing some mobile devices keywords  
      to search it in details string*/
    let regexp = /android|iphone|kindle|ipad/i;

    /* Using test() method to search regexp in details 
      it returns boolean value*/
    let isMobileDevice = regexp.test(details);

    if (isMobileDevice) {
      this.setState({ mobile: true });
    } else {
      this.setState({ mobile: false });
    }
  };

  Fnavbar = () => {
    let Usernavbar = GenPortraits(this.state.mobile, this.props.imgcredits);
    return Usernavbar;
  };

  render() {
    return (
      <React.Fragment>
        <AiComposzNavbarenh
          user_id={this.state.userID}
          user_name={this.state.userName}
        />
        <this.Fnavbar />
      </React.Fragment>

      //   <div style={{ paddingLeft: 200 }}>
      //     <h3>Welcome to Enhance Images!</h3>
      //   </div>
    );
  }
}
export default Enhance;
